export enum RewardsQueryKeys {
  Primary = '/rewards',
}
